<template>
  <v-ons-page>

    <v-ons-toolbar class="toolbar--noshadow" modifier="perfhome">
      <div class="left">
        <v-ons-back-button v-if="! $md"></v-ons-back-button>
        <v-ons-toolbar-button v-else @click="pageStack.pop()">
          <v-ons-icon icon="md-arrow-left" size="24px"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
      <div class="center">Partage du compte</div>
    </v-ons-toolbar>

    <div class="content content--perfonglet">

      <app-error-msg :list="errorMsgList"></app-error-msg>

      <v-ons-list v-if="user.share && user.share.length" modifier="noborder perflist">
        <v-ons-list-item v-for="(item, index) in user.share" :key="index" modifier="perfcult">
          <div class="center">
            <span class="list-item__title">
              {{ item.email }}
            </span>
          </div>
          <div class="right" @click="deleteShareConfirm(index)">
            <v-ons-progress-circular v-if="isSubmitDelete === index" :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
            <v-ons-icon v-else icon="trash"></v-ons-icon>
          </div>
        </v-ons-list-item>
      </v-ons-list>

      <div v-else class="content--perfalert__empty" style="height: calc(100% - 90px);">
        <section>
          <img src="../assets/imgs/icon_wait_bg@2x.png" />
          <template>
            <h3>Partagez l'accès à votre compte</h3>
            <p>Indiquez les adresses emails pour leur permettre d'accéder à votre compte&nbsp;!</p>
          </template>
        </section>
      </div>

      <v-ons-bottom-toolbar modifier="cta transparent">
        <v-ons-button @click="showNewShare" modifier="large--cta perflarge">
          Partager mon compte
        </v-ons-button>
      </v-ons-bottom-toolbar>

    </div>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';

import { store } from "../store.js";

import AppErrorMsg from '../partials/ErrorMsg.vue';
import AppParamsShareNew from './ParamsShareNew.vue';

export default {
  mixins: [mixinsCommons],
  components: { AppErrorMsg },
  props: ['pageStack'],
  data() {
    return {
      state: store.state,
      data: store.data
    };
  },
  computed: {
    user() {
      return this.state.user;
    },
  },
  methods: {
    showNewShare() {
      this.pageStack.push(AppParamsShareNew);
    },
    deleteShareConfirm(indexShare) {
      if (this.isSubmitDelete !== false) {
        return;
      }
      this.$ons.notification.confirm({
        modifier: this.$mdModifier,
        title: 'Pas si vite !',
        message: "Êtes-vous sûr de vouloir supprimer ce partage ?",
        buttonLabels: ['Annuler', 'Supprimer'],
        cancelable: true,
        callback: function (index) {
          if (index === 1) { // -1 if canceled
            this.deleteShare(indexShare);
          }
        }.bind(this)
      });
    },
    async deleteShare(indexShare) {
      this.isSubmitDelete = indexShare;
      var share = this.user.share[indexShare];

      const call = {
        method: 'DELETE',
        path: this.getPath('/share'),
        data: {
          id: this.user.id,
          date: this.user.date,
          id_to: share.id,
        }
      };

      const fetchInit = this.$getFetchInit(call.method);
      fetchInit.body = JSON.stringify(call.data);
      const callPath = this.$apiDomain + call.path;
      try {
        const response = await this.handleRequest(callPath, fetchInit);

        this.updateUserFromResponse(response.user);

        if(response.multi && Object.keys(response.multi).length){
          this.$emit('set-multi', response.multi);
        }

        this.$showToast('Partage supprimé');

      } catch(error) {
        this.handleError(error, 'de la suppression');
      }
      this.isSubmitDelete = false;
    }
  }
};
</script>
